import { render, staticRenderFns } from "./ResultadoInscripcionConMensaje.vue?vue&type=template&id=6355caf4&"
import script from "./ResultadoInscripcionConMensaje.vue?vue&type=script&lang=js&"
export * from "./ResultadoInscripcionConMensaje.vue?vue&type=script&lang=js&"
import style0 from "./ResultadoInscripcionConMensaje.vue?vue&type=style&index=0&id=6355caf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports